var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"br-doc-item__warning"},[_c('img',{staticClass:"br-doc-item__warning-icon",attrs:{"src":_vm.iconUrl,"width":"20","height":"20","alt":""}}),_c('p',{staticClass:"br-doc-item__warning-text"},[_vm._v(_vm._s(_vm.$t('lbl_EMPBE_BR_List_ExpiredSoon')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }